import { ApiCalls } from '../../../api/api';
import { TimeUser } from '../../../api/generated/data-contracts';
import { validationRules } from '../../validationRules';
import { ValidateResponse } from '../../Validator';
import { FlowValidationConfigValues } from './FlowValidationConfg';

interface FlowValdationProps {
    userPeriodId: string;
    user: TimeUser;
    [key: string]: any;
}

export const FlowValidation = async (props: FlowValdationProps): Promise<ValidateResponse> => {
    const flowUrl = props[FlowValidationConfigValues.FlowUrl];

    if (!flowUrl?.startsWith('http')) {
        console.error(`FLOW_URL IS NOT CONFIGURED CORRECTLY (${flowUrl})`);
        const response: ValidateResponse = {
            reason: '',
            valid: true,
            name: validationRules.useFlowValidation,
            rejected: false,
        };

        return response;
    } else {
        const response = await ApiCalls.validationPowerautomateCreate({ userPeriodId: props.userPeriodId });

        const result: ValidateResponse = {
            reason: response.data.reason,
            valid: response.data.valid,
            name: validationRules.useFlowValidation,
            rejected: response.data.rejected !== undefined ? response.data.rejected : !response.data.valid,
        };

        return result;
    }
};
